/* eslint-disable */
export default {
  dialer: 'Tec. de marc.',
  allCalls: 'Todas las llamadas',
} as const;

// @key: @#@"dialer"@#@ @source: @#@"Dial Pad"@#@
// @key: @#@"allCalls"@#@ @source: @#@"All Calls"@#@
